import React from "react";
import "./PUCApply.css"; 
import { useNavigate } from "react-router-dom";
import { FcServices } from "react-icons/fc";

import twoImg from "../assets/2w.png";
import fourImg from "../assets/4w.png";

const pucServices = [
  { name: "PUC for 2 Wheeler", img: twoImg, path: "/dashboard/puc-apply-2w" },
  { name: "PUC for 4 Wheeler", img: fourImg, path: "/dashboard/puc-apply-4w" }
];

export default function PUCApply() {
  const navigate = useNavigate();

  return (
    <div className="puc-wrapper">

      <h2 className="puc-title">
        <FcServices className="puc-icon" /> Select PUC Service
      </h2>

      <div className="puc-divider"></div>

      <div className="puc-services-box">

        {pucServices.map((item, i) => (
          <div className="puc-card" key={i}>
            <div className="puc-circle" onClick={() => navigate(item.path)}>
              <img src={item.img} alt={item.name} draggable="false" />
            </div>
            <p className="puc-name">{item.name}</p>
          </div>
        ))}

      </div>
    </div>
  );
}
